import { TitleCasePipe } from '@angular/common';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'; 
import * as moment from 'moment';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { Dropdown } from 'primeng/dropdown';
import { Table } from 'primeng/table';
import { ScheduleService } from 'src/app/services/schedule.service';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-partner-list',
  templateUrl: './userschedule-list.component.html',
  styleUrls: ['./userschedule-list.component.scss'],
  providers: [MessageService, ConfirmationService, TitleCasePipe]
})

export class UserscheduleListComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  searchBy: any[];
  searchby;
  startDate: Date;
  endDate: Date;
  partnerlist: any = [];
  totalRecords: 0;
  loading: boolean;
  paginationOption;
  Ammenity;
  downloadFlg: boolean;
  errorMessage = '';
  id: any;
  hideImage: boolean = false;
  ammentystatus: boolean = false;
  hidestatus: boolean = false
  errormessage = '';
  public hide: boolean = true;
  private lastTableLazyLoadEvent: LazyLoadEvent;
  username: string;
  userName;
  calvalue: Date;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  opponentUserName: string;
  charges: string;
  statename: string;
  cityname: string;
  venue: string;
  constructor(private route: ActivatedRoute, private router: Router, private scheduleservice: ScheduleService, private confirmationservice: ConfirmationService, private titlecasePipe: TitleCasePipe, private messageService: MessageService,) { }

  ngOnInit(): void {
    this.Ammenity = environment.amenitiesArray
    this.paginationOption = environment.pagination;
    this.id = this.route.snapshot.paramMap.get("id");
    this.downloadFlg = false;

    this.searchBy = [
      { label: 'Created On', value: "created_at" },
      { label: 'Last Modified On', value: "updated_at" },
      { label: 'Pending', value: "created_at", status: 'Pending' },
      { label: 'Booked', value: "booked_at", status: 'Booked' },
      { label: 'Approved', value: "approved_at", status: 'Approved' },
      { label: 'Rejected', value: "rejected_at", status: 'Rejected' },
    ];
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = '';


    this.opponentUserName = '';
    this.charges = '';
    this.statename = '';
    this.cityname = '';
  this.venue = '';
      this.dt.clear();
    this.dt.filter('', 'opponentUserName', 'contains')
    this.dt.filter('', 'time', 'contains');
    this.dt.filter('', 'charges', 'contains');
    this.dt.filter('', 'statename', 'contains');
    this.dt.filter('', 'cityname', 'contains');
    this.dt.filter('', 'venue', 'dateIs');
    this.dt.filter('', 'startDate', 'dateIs');
    this.calvalue = null; 
    this.pDropDownId.clear(null);
    if (this.pDropDownId) {
      this.pDropDownId.value = '';
    }
  }


  loadschedulelist(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByUserId=" + this.id;
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = (event.first / event.rows) + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }

    if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
      params += "&filterByDate=" + this.searchby.status;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");

      if (this.searchby.label === 'Booked') {
        this.hidestatus = true
      }
      else {
        this.hidestatus = false
      }
    }

    if (event.filters != undefined && event.filters["opponentUserName"] != undefined) {
      params += "&filterByName=" + event.filters["opponentUserName"].value;
    }
    if (event.filters != undefined && event.filters["time"] != undefined) {
      params += "&filterByTime=" + event.filters["time"].value;
    }
    if (event.filters != undefined && event.filters["charges"] != undefined) {
      params += "&filterBychargesperhour=" + event.filters["charges"].value;
    }
    if (event.filters != undefined && event.filters["statename"] != undefined) {
      params += "&filterBystate=" + event.filters["statename"].value;
    }

    if (event.filters != undefined && event.filters["cityname"] != undefined) {
      params += "&filterBystate=" + event.filters["cityname"].value;
    }
    if (event.filters != undefined && event.filters["venue"] != undefined) {
      params += "&filterByvenues=" + event.filters["venue"].value;
    }
    if (event.filters != undefined && event.filters["startDate"] != undefined) {
        const startDate = moment(event.filters["startDate"].value).format("YYYY-MM-DD");
        params += "&filterByStartDate=" + startDate;
    }
    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.scheduleservice.getScheduleList(query).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.username = data?.data?.userInfo?.name;
        this.loading = false;
        this.partnerlist = this.buildScheduleSlotRows(data?.data?.items);
        this.totalRecords = data.data.totalCount;
        this.userName = this.partnerlist?.length ? this.partnerlist[0].userName : null;
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );



  }
  setDownloadFlag() {
    this.downloadFlg = false;
  }

  approveuser(user) {
    this.confirmationservice.confirm({
      message: 'Are you sure to Approve ' + (this.titlecasePipe.transform(user.opponentUserName)) + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        var disableStatus;
        if (user.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }

        var userStatus = '{"bookingStatus":' + disableStatus + '}'
        this.scheduleservice.updatestatus(user.opponentUserId, userStatus).pipe(takeUntil(this.destroy$)).subscribe(data => {
          this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'User Status Updated', life: 3000 })
          this.loadschedulelist(this.lastTableLazyLoadEvent)

        },
          err => {
            this.errormessage = err.error.message
          }
        );
      },
      reject: () => {

      }
    })
  }

  rejectuser(user) {
    this.confirmationservice.confirm({
      message: 'Are you sure to reject ' + (this.titlecasePipe.transform(user.userName)) + '?',
      header: 'confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        var disableStatus;
        if (user.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }

        // bookingStatus:'Approved'
        var userStatus = '{"bookingStatus":' + disableStatus + '}'
        this.scheduleservice.updatestatus(user.userId, userStatus).pipe(takeUntil(this.destroy$)).subscribe(data => {
          this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'User Rejected', life: 3000 })
          this.loadschedulelist(this.lastTableLazyLoadEvent)

        },
          err => {
            this.errormessage = err.error.message
          }
        );
      },
      reject: () => {

      }
    })
  }

  isReturnButtonDisabled(user) {
    const slotPrice = Number(user?.charges);
    return !user?.opponentUserId || isNaN(slotPrice) || slotPrice <= 0;
  }

  returnCash(user) {
    if (this.isReturnButtonDisabled(user)) {
      return;
    }

    this.confirmationservice.confirm({
      // message: 'Are you sure you want to refund cash to' + (this.titlecasePipe.transform(user.opponentUserName)) + '?',
      // header: 'confirm',
      // icon: 'pi pi-exclamation-triangle',
      
  message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to refund cash ?
      </p>
    `,
      // message: 'Are you sure you want to delete this image ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
    rejectLabel: 'Cancel',
      // ❌ Remove icons
    acceptIcon: '',
    rejectIcon: '' , 

      accept: () => {
        var disableStatus;
        if (user.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }

        // bookingStatus:'Approved'
        var userStatus = '{"bookingStatus":' + disableStatus + '}'
        this.scheduleservice.cashReturn(user.id, userStatus).pipe(takeUntil(this.destroy$)).subscribe(data => {
          this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'User cash transfered', life: 3000 })
          this.loadschedulelist(this.lastTableLazyLoadEvent)

        },
          err => {
            this.errormessage = err.error.message
          }
        );
      },
      reject: () => {

      }
    })
  }
  downloadPdf(invoiceFile) {
    window.open(invoiceFile);
  }

  buildDisplayTimeSlots(partner) {
    const slots = partner?.timeSlots?.length ? partner.timeSlots : [partner];
    return slots.map(slot => ({
      startTime: this.formatDisplayTime(slot.startDate || slot.startTime || partner.startDate),
      endTime: this.formatDisplayTime(slot.endDate || slot.endTime || partner.endDate)
    }));
  }

  buildScheduleSlotRows(items) {
    const scheduleSlotRows = [];

    (items || []).forEach(partner => {
      const slots = partner?.timeSlots?.length ? partner.timeSlots : [partner];

      slots.forEach(slot => {
        scheduleSlotRows.push({
          ...partner,
          ...slot,
          parentScheduleId: partner?.id,
          timeSlots: [slot],
          amenityImg: this.buildAmenityImages(partner?.amenities),
          displayTimeSlots: [{
            startTime: this.formatDisplayTime(slot?.startDate || slot?.startTime || partner?.startDate),
            endTime: this.formatDisplayTime(slot?.endDate || slot?.endTime || partner?.endDate)
          }]
        });
      });
    });

    return scheduleSlotRows;
  }

  buildAmenityImages(amenities) {
    const imgarray = [
      { slug: 'ball', img: 'assets/img/schedule-icon/tennis-ball-svgrepo-com.svg', status: false },
      { slug: 'court', img: 'assets/img/schedule-icon/tennis-court-svgrepo-com.svg', status: false },
      { slug: 'tennis_racket', img: 'assets/img/schedule-icon/tennis-racket-svgrepo-com.svg', status: false }
    ];

    (amenities || []).forEach(amenity => {
      const amenitySlug = this.normalizeAmenitySlug(amenity?.slug);
      const amenityImage = imgarray.find(obj => obj.slug === amenitySlug);

      if (amenityImage) {
        amenityImage.status = true;
      }
    });

    return imgarray;
  }

  normalizeAmenitySlug(slug) {
    return String(slug || '').trim().toLowerCase().replace(/\s+/g, '_');
  }

  formatDisplayTime(value) {
    if (!value) {
      return '';
    }
    const timeValue = String(value);
    const parsedTime = moment(timeValue, ['HH:mm', 'H:mm', 'hh:mm A', 'h:mm A'], true);
    if (parsedTime.isValid()) {
      return parsedTime.format('h:mm a');
    }
    const parsedDate = moment(value);
    return parsedDate.isValid() ? parsedDate.format('h:mm a') : timeValue;
  }

  //use to add columns
  addColumns() {
    this.hide = false;

  }

  //use to remove columns
  removeColumns() {
    this.hide = true;
  }

  viewChatHistory(partner: any) {
      this.router.navigate([
          '/manage/customer/user/userscheduleList', 
          this.id,
          'find-partner-chat-history',
          partner.userId,
          partner.opponentUserId
      ]);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
